import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '../../lib/shadcn/select'
import type { Unit } from '../../utils/units'

interface UnitSelectProps {
  value: string
  onChange: (unit: string) => void
  units: Unit[]
  placeholder?: string
  disabled?: boolean
  className?: string
  id?: string
  /** Restrict the options to one or more measurement types. */
  filterType?: UnitType | UnitType[]
}

type UnitType = 'weight' | 'volume' | 'count'

const TYPE_LABELS: Record<string, string> = {
  weight: 'Weight',
  volume: 'Volume',
  count: 'Count',
}

// Managed-unit picker shared by the ingredient and recipe forms. Units are
// grouped by measurement type (weight / volume / count).
export default function UnitSelect({
  value,
  onChange,
  units,
  placeholder = 'Unit',
  disabled = false,
  className,
  id,
  filterType,
}: UnitSelectProps) {
  // Group units by type, preserving the order they arrive in.
  const allowed = filterType == null ? null : Array.isArray(filterType) ? filterType : [filterType]
  const groups: { type: string; units: Unit[] }[] = []
  for (const u of units) {
    if (allowed && !allowed.includes(u.unit_type as UnitType)) continue
    let g = groups.find(x => x.type === u.unit_type)
    if (!g) {
      g = { type: u.unit_type, units: [] }
      groups.push(g)
    }
    g.units.push(u)
  }

  return (
    <Select
      {...(value ? { value } : {})}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectTrigger id={id} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {groups.map(g => (
          <SelectGroup key={g.type}>
            <SelectLabel>{TYPE_LABELS[g.type] ?? g.type}</SelectLabel>
            {g.units.map(u => (
              <SelectItem key={u.id} value={u.name}>
                {u.name}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  )
}
